module.exports = __webpack_public_path__ + "img/teaching_4.b00ead04.png";